import React from "react";
import { Card, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector, batch } from "react-redux";
import t from "../../Actions/EdgeDeviceActions/types";
import * as EdgeDeviceActions from "../../Actions/EdgeDeviceActions/action";
import styled from "styled-components";
import PerfectScrollbar from "react-perfect-scrollbar";
import Select from "react-select";
import _ from "lodash";

const AddEdgeDeviceTypeFunc = () => {
  const dispatch = useDispatch();
  const scrollRef = React.useRef();
  const macRegex = React.useRef(
    /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$|^[0-9a-fA-F]{4}\\.[0-9a-fA-F]{4}\\.[0-9a-fA-F]{4}$/
  ).current;
  const [validations, setValidations] = React.useState({});
  const modalRef = React.useRef(null);
  const configData = useSelector((state) => state.EdgeDeviceDetails.deviceData);
  const edgeDevices = useSelector(
    (state) => state.EdgeDeviceDetails.edgeDevices
  );
  const lotData = useSelector((state) => state.EdgeDeviceDetails.lotData);
  const laneData = useSelector((state) => state.EdgeDeviceDetails.laneData);
  const cameraData = useSelector((state) => state.EdgeDeviceDetails.cameraData);
  const apiMessage = useSelector((state) => state.EdgeDeviceDetails.message);
  const modelOpenCLose = useSelector(
    (state) => state.EdgeDeviceDetails.modelOpenClose
  );
  const searchParams = window.document.location.href.split("?")[1];
  const prevData = React.useRef("");
  const prevExec = React.useRef(false);
  const selectedDeviceType = useSelector(
    (state) => state.EdgeDeviceDetails.selectedDeviceType
  );

  const IpChanges = React.useCallback(
    (e) => {
      const whiteListIP = e.target.value;
      let errorMessage = "";
      if (whiteListIP) {
        const whiteListIPRegex =
          /^((?:\d|\d\d|1\d\d|2[0-4]\d|25[0-5])[.]){3}(?:\d|\d\d|1\d\d|2[0-4]\d|25[0-5])$/;

        errorMessage = !whiteListIPRegex.test(whiteListIP)
          ? `Please enter proper ${e.target.name.split("_").join(" ")}.`
          : "";
      }
      setValidations((validation) => ({
        ...validation,
        [e.target.name]: errorMessage,
      }));
      if (e.nativeEvent.data === "." || !isNaN(Number(e.nativeEvent.data))) {
        dispatch({
          type: t.SET_EDGE_DEVICE_DATA,
          payload: {
            ...configData,
            [e.target.name]: e.target.value,
          },
        });
      } else if (
        e.target.value.length <= 1 &&
        isNaN(Number(e.nativeEvent.data))
      ) {
        dispatch({
          type: t.SET_EDGE_DEVICE_DATA,
          payload: {
            ...configData,
            [e.target.name]: "",
          },
        });
      }
    },
    [dispatch, configData]
  );
  const PortChanges = React.useCallback(
    (e) => {
      const whiteListPort = e.target.value;
      let errorMessage = "";
      if (whiteListPort) {
        const whiteListPortRegEx = /^\d*$/;
        if (!whiteListPortRegEx.test(whiteListPort)) {
          errorMessage = "Characters not allowed";
        }
        if (!_.inRange(whiteListPort, 0, 65353)) {
          /* whiteListPort varies from 0 to 65353 */
          errorMessage = `Please enter proper ${e.target.name
            .split("_")
            .join(" ")}.`;
        }
      }

      setValidations((validation) => ({
        ...validation,
        [e.target.name]: errorMessage,
      }));
      if (!isNaN(Number(e.nativeEvent.data))) {
        dispatch({
          type: t.SET_EDGE_DEVICE_DATA,
          payload: {
            ...configData,
            [e.target.name]: e.target.value,
          },
        });
      } else if (
        e.target.value.length <= 1 &&
        isNaN(Number(e.nativeEvent.data))
      ) {
        dispatch({
          type: t.SET_EDGE_DEVICE_DATA,
          payload: {
            ...configData,
            [e.target.name]: "",
          },
        });
      }
    },
    [dispatch, configData]
  );

  const MacIdValidate = React.useCallback(
    (e) => {
      const macID = e.target.value;
      let errorMessage = "";
      if (macID) {
        errorMessage =
          macID.replace(/[^a-zA-Z0-9:-]/g, "").length > 17
            ? `${e.target.name.split("_").join(" ").toLowerCase()} is invalid.`
            : "";
      }
      if (!macID) {
        errorMessage = `${e.target.name.split("_").join(" ")} is required.`;
      } else if (!errorMessage) {
        if (!macRegex.test(e.target.value.replace(/[^a-zA-Z0-9:-]/g, ""))) {
          errorMessage = "mac id is invalid.";
        }
      }
      setValidations((validation) => ({
        ...validation,
        [e.target.name]: errorMessage,
      }));
      dispatch({
        type: t.SET_EDGE_DEVICE_DATA,
        payload: {
          ...configData,
          [e.target.name]: e.target.value
            .replace(/[^a-zA-Z0-9:-]/g, "")
            .toLowerCase(),
        },
      });
    },
    [dispatch, configData]
  );

  const ModeValidate = React.useCallback(
    (e) => {
      const ModeNumber = e.target.value;
      let errorMessage = "";
      if (!ModeNumber) {
        errorMessage = `${e.target.name.split("_").join(" ")} is required.`;
      }
      setValidations((validation) => ({
        ...validation,
        [e.target.name]: errorMessage,
      }));
    },
    [dispatch, configData]
  );

  const SerialValidate = React.useCallback(
    (e) => {
      const serialNumber = e.target.value;
      let errorMessage = "";
      if (serialNumber) {
        errorMessage =
          serialNumber.replace(/[^a-zA-Z0-9:-]/g, "").length > 12
            ? `${e.target.name.split("_").join(" ")} is invalid.`
            : "";
      }
      if (!serialNumber) {
        errorMessage = `${e.target.name.split("_").join(" ")} is required.`;
      }
      setValidations((validation) => ({
        ...validation,
        [e.target.name]: errorMessage,
      }));
      dispatch({
        type: t.SET_EDGE_DEVICE_DATA,
        payload: {
          ...configData,
          [e.target.name]: e.target.value.replace(/[^a-zA-Z0-9:-]/g, ""),
        },
      });
    },
    [dispatch, configData]
  );

  const handleChange = React.useCallback(
    (e) => {
      if (e.target.type === "number" || e.target.type === "tel") {
        if (!isNaN(Number(e.nativeEvent.data))) {
          dispatch({
            type: t.SET_EDGE_DEVICE_DATA,
            payload: {
              ...configData,
              [e.target.name]: +e.target.value.replace(/[^*\d\s]/gi, ""),
            },
          });
        } else if (
          e.target.value.length <= 1 &&
          isNaN(Number(e.nativeEvent.data))
        ) {
          dispatch({
            type: t.SET_EDGE_DEVICE_DATA,
            payload: {
              ...configData,
              [e.target.name]: "",
            },
          });
        }
      } else if (e.target.name === "mac_id") {
        MacIdValidate(e);
      } else if (e.target.name === "serial_number") {
        SerialValidate(e);
      } else if (e.target.name === "mode") {
        ModeValidate(e);
      } else if (
        [
          "white_list_ip",
          "server_ip",
          "camera_ip",
          "axis_server_ip",
          "axis_camera_ip",
          "lmps_ip",
        ].indexOf(e.target.name) !== -1
      ) {
        IpChanges(e);
      } else if (
        ["white_list_port", "server_port", "lmps_port"].indexOf(
          e.target.name
        ) !== -1
      ) {
        PortChanges(e);
      } else if (
        e.target.name === "passage_pass_location" ||
        e.target.name === "passage_pass_key"
      ) {
        dispatch({
          type: t.SET_EDGE_DEVICE_DATA,
          payload: {
            ...configData,
            [e.target.name]: e.target.value,
          },
        });
      } else {
        console.log("serial number validation called:---====");
        setValidations((validation) => ({
          ...validation,
          [e.target.name]: e.target.value
            ? ""
            : `${e.target.name.split("_").join(" ")} is required.`,
        }));
        dispatch({
          type: t.SET_EDGE_DEVICE_DATA,
          payload: {
            ...configData,
            [e.target.name]:
              e.target.name === "device_name"
                ? e.target.value.replace(/[^\w\s]/gi, "")
                : e.target.value,
          },
        });
      }
    },
    [
      configData,
      IpChanges,
      PortChanges,
      MacIdValidate,
      SerialValidate,
      ModeValidate,
    ]
  );

  const handleCheckboxChange = React.useCallback(
    (e) => {
      dispatch({
        type: t.SET_EDGE_DEVICE_DATA,
        payload: { ...configData, [e.target.name]: e.target.checked },
      });
    },
    [configData]
  );

  const handleClose = React.useCallback(() => {
    dispatch({
      type: t.CLOSE_OPEN_MODEL,
      payload: false,
    });
    batch(() => {
      dispatch({
        type: t.SET_EDGE_DEVICE_DATA,
        payload: {},
      });
      dispatch({
        type: t.SET_DEVICE_TYPE,
        payload: [],
      });
      dispatch({
        type: t.CLOSE_OPEN_MODEL,
        payload: false,
      });
    });
  }, []);

  const ValidateIPaddress = React.useCallback((ipaddress) => {
    return !!/^(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)$/.test(
      ipaddress
    );
  }, []);

  const CommonValidation = React.useCallback(
    (validation) => {
      if (configData.server_ip && !ValidateIPaddress(configData.server_ip)) {
        validation.server_ip = "Please enter proper IP Address.";
      }
      if (configData.server_port && isNaN(configData.server_port)) {
        validation.server_port = "Please enter proper Port.";
      }
    },
    [configData]
  );

  const ILCValidation = React.useCallback(
    (validation) => {
      CommonValidation(validation);
      if (configData.camera_ip && !ValidateIPaddress(configData.camera_ip)) {
        validation.camera_ip = "Please enter proper IP Address.";
      }
      return validation;
    },
    [CommonValidation, configData]
  );

  const SILCValidation = React.useCallback(
    (validation) => {
      CommonValidation(validation);
      if (
        configData.axis_server_ip &&
        !ValidateIPaddress(configData.axis_server_ip)
      ) {
        validation.axis_server_ip = "Please enter proper IP Address.";
      }
      if (configData.lpms_ip && !ValidateIPaddress(configData.lpms_ip)) {
        validation.lpms_ip = "Please enter proper IP Address.";
      }
      if (configData.lpms_port && isNaN(configData.lpms_port)) {
        validation.lpms_port = "Please enter proper Port.";
      }
      return validation;
    },
    [CommonValidation, configData]
  );

  const FeedbackValidation = React.useCallback(
    (validation) => {
      CommonValidation(validation);
      if (configData.camera1_ip && !ValidateIPaddress(configData.camera1_ip)) {
        validation.camera1_ip = "Please enter proper IP Address.";
      }
      if (configData.camera2_ip && !ValidateIPaddress(configData.camera2_ip)) {
        validation.camera2_ip = "Please enter proper IP Address.";
      }
      return validation;
    },
    [CommonValidation, configData]
  );

  const TicketDispenserValidation = React.useCallback(
    (validation) => {
      CommonValidation(validation);
      if (configData.camera1_ip && !ValidateIPaddress(configData.camera1_ip)) {
        validation.camera1_ip = "Please enter proper IP Address.";
      }
      if (configData.camera2_ip && !ValidateIPaddress(configData.camera2_ip)) {
        validation.camera2_ip = "Please enter proper IP Address.";
      }
      return validation;
    },
    [CommonValidation, configData]
  );

  const config = React.useMemo(
    () =>
      (selectedDeviceType || []).sort((a, b) =>
        a.createdAt > b.createdAt ? -1 : 1
      ),
    [selectedDeviceType]
  );

  const cameraOptions = React.useMemo(() => {
    return (cameraData ?? [])
      .filter((lane) => lane.lane.id === configData.lane_id)
      .map((lane) => ({ value: lane.id, label: lane.ip_addr }));
  }, [configData.lane_id, cameraData]);

  const lotOptions = React.useMemo(() => {
    return (lotData ?? []).map((lot) => ({ value: lot.id, label: lot.alias }));
  }, [lotData]);

  const laneOptions = React.useMemo(() => {
    return (
      laneData &&
      laneData.length &&
      laneData
        .filter((lane) => lane.lot.id === configData.lot_id)
        .map((lane) => ({ value: lane.id, label: lane.alias }))
    );
  }, [configData.lot_id, laneData]);

  const CheckValidation = React.useCallback(() => {
    const basicData =
      configData.type === "VPC" ||
      configData.type === "ILC" ||
      configData.type === "SILC" ||
      configData.type === "Feedback" ||
      configData.type === "TicketDispenser" ||
      configData.type === "PaymentKiosk"
        ? ["type", "device_name", "lot_id", "lane_id", "mac_id", "camera_id"]
        : ["type", "device_name", "mac_id"];
    let allvalidations = {};
    if (configData.type === "PaymentKiosk") {
      basicData.pop();
      basicData.push("serial_number");
      basicData.push("mode");
    }
    if (configData.type === "TicketDispenser") {
      basicData.pop();
      basicData.push("serial_number");
    }
    basicData.forEach((bd) => {
      if (
        !configData[bd] ||
        (bd === "camera_id" &&
          !cameraOptions.some((x) => x.value === configData[bd])) ||
        (bd === "lot_id" &&
          !lotOptions.some((x) => x.value === configData[bd])) ||
        (bd === "lane_id" &&
          !laneOptions.some((x) => x.value === configData[bd]))
      ) {
        allvalidations[bd] = `${bd
          .replace("_", " ")
          .split("id")
          .join("")} is required.`;
        if (allvalidations[bd] === "type is required.") {
          allvalidations[bd] = "Device Type is required.";
        }
        if (allvalidations[bd] === "device name is required.") {
          allvalidations[bd] = "Device Name is required.";
        }
        if (allvalidations[bd] === "lot  is required.") {
          allvalidations[bd] = "Lot is required.";
        }
        if (allvalidations[bd] === "lane  is required.") {
          allvalidations[bd] = "Lane is required.";
        }
        if (allvalidations[bd] === "camera  is required.") {
          allvalidations[bd] = "Camera is required.";
        }
        if (allvalidations[bd] === "mac  is required.") {
          allvalidations[bd] = "MAC ID is required.";
        }
        if (allvalidations[bd] === "serial number is required.") {
          allvalidations[bd] = "Serial Number is required.";
        }
        if (allvalidations[bd] === "mode is required.") {
          allvalidations[bd] = "Mode is required.";
        }
      }
    });
    if (configData.mac_id && !allvalidations.mac_id) {
      if (
        !macRegex.test(configData.mac_id || configData.mac_id.length === 17)
      ) {
        allvalidations.mac_id = "Please enter proper mac address...";
      }
    }
    if (configData.white_list_ip) {
      const whiteListIPRegex =
        /^((?:\d|\d\d|1\d\d|2[0-4]\d|25[0-5])[.]){3}(?:\d|\d\d|1\d\d|2[0-4]\d|25[0-5])$/;
      if (!whiteListIPRegex.test(configData.white_list_ip)) {
        allvalidations.white_list_ip =
          "Please enter proper whitelist ip address.";
      }
    }
    if (configData.white_list_port) {
      const whiteListPortRegEx = /^\d*$/;
      if (!whiteListPortRegEx.test(configData.white_list_port)) {
        allvalidations.white_list_port = "Please enter proper whitelist port.";
      }
    }
    if (configData.axis_retry_count) {
      if (isNaN(configData.axis_retry_count)) {
        allvalidations.axis_retry_count = "Please enter proper value";
      }
    }
    for (const cfg of config) {
      if (cfg.field_validation_regex) {
        if (configData[cfg.field_name]) {
          const regex = new RegExp(cfg.field_validation_regex);
          if (!regex.test(configData[cfg.field_name])) {
            allvalidations[
              cfg.field_name
            ] = `${cfg.field_label.toLowerCase()} is invalid.`;
          }
        }
      }
    }
    if (configData.type === "ILC") {
      allvalidations = ILCValidation(allvalidations);
    } else if (configData.type === "SILC") {
      allvalidations = SILCValidation(allvalidations);
    } else if (configData.type === "Feedback") {
      allvalidations = FeedbackValidation(allvalidations);
    } else if (configData.type === "TicketDispenser") {
      allvalidations = TicketDispenserValidation(allvalidations);
    }
    setValidations(allvalidations);
    console.log("allvalidations:===", allvalidations);
    console.log("edge device values", configData);

    return Object.keys(allvalidations).length > 0;
  }, [
    config,
    configData,
    ILCValidation,
    lotOptions,
    laneOptions,
    cameraOptions,
  ]);

  const handleAddFields = React.useCallback(() => {
    if (CheckValidation()) {
      return;
    }
    batch(() => {
      dispatch(
        EdgeDeviceActions.addEdgeDevice({
          ...configData,
          property_id: searchParams,
          old_data: edgeDevices.find((x) => x.id === configData?.id),
        })
      );
    });
  }, [dispatch, configData, searchParams, CheckValidation]);

  React.useEffect(() => {
    if (
      selectedDeviceType &&
      !(configData && configData.id) &&
      !prevExec.current
    ) {
      const data = {};
      prevExec.current = true;
      console.log("selectedDeviceType:======", selectedDeviceType);
      selectedDeviceType.forEach((deviceData) => {
        if (deviceData.field_type === "text") {
          data[deviceData.field_name] = "";
        } else if (deviceData.field_type === "number") {
          data[deviceData.field_name] = 0;
        } else if (deviceData.field_type === "switch") {
          data[deviceData.field_name] = false;
        } else if (deviceData.field_type === "dropdown") {
          data[deviceData.field_name] = "";
        }
      });
      dispatch({
        type: t.SET_EDGE_DEVICE_DATA,
        payload: data,
      });
    }
  }, [selectedDeviceType, configData]);

  React.useEffect(() => {
    if (configData && configData.id && prevData.current !== configData.type) {
      prevData.current = configData.type;
      dispatch(EdgeDeviceActions.fetchFieldsForDeviceType(configData.type));
    }
  }, [configData]);

  const deviceTypes = useSelector(
    (state) => state.EdgeDeviceDetails.deviceTypes
  );

  const changeDeviceType = React.useCallback(
    (e) => {
      batch(() => {
        dispatch(EdgeDeviceActions.fetchFieldsForDeviceType(e.target.value));
        dispatch({
          type: t.SET_EDGE_DEVICE_DATA,
          payload: { type: e.target.value, device_name: "" },
        });
        setValidations((validation) => ({ type: null }));
      });
    },
    [dispatch, configData]
  );

  const changeDeviceTypeDropdown = React.useCallback(
    (e) => {
      console.log("dropdown value on e.target.value:====", e.target.value);
      dispatch({
        type: t.SET_EDGE_DEVICE_DATA,
        payload: { ...configData, [e.target.name]: e.target.value },
      });
      setValidations((validation) => ({ ...validation, dropdownField: null }));
    },
    [dispatch, configData]
  );

  const changeLane = React.useCallback(
    (e) => {
      dispatch({
        type: t.SET_EDGE_DEVICE_DATA,
        payload: { ...configData, lane_id: e.value },
      });
      setValidations((validation) => ({ ...validation, lane_id: null }));
    },
    [dispatch, configData]
  );

  const changeLot = React.useCallback(
    (e) => {
      dispatch({
        type: t.SET_EDGE_DEVICE_DATA,
        payload: { ...configData, lot_id: e.value, lane_id: null },
      });
      if (configData.type === "VPC") {
        setValidations((validation) => ({ ...validation, lot_id: null }));
      }
    },
    [dispatch, configData]
  );

  const changeCamera = React.useCallback(
    (e) => {
      dispatch({
        type: t.SET_EDGE_DEVICE_DATA,
        payload: { ...configData, camera_id: e.value },
      });
      setValidations((validation) => ({ ...validation, camera_id: null }));
    },
    [dispatch, configData]
  );

  const changeCameraType = React.useCallback(
    (e) => {
      dispatch({
        type: t.SET_EDGE_DEVICE_DATA,
        payload: { ...configData, camera_type: e.value },
      });
      setValidations((validation) => ({ ...validation, camera_type: null }));
    },
    [dispatch, configData]
  );

  React.useEffect(() => {
    if (apiMessage && !apiMessage.isSuccess && apiMessage.message) {
      scrollRef.current._ps.element.scrollTo = 0;
    }
  }, [apiMessage]);

  React.useEffect(() => {
    batch(() => {
      dispatch(EdgeDeviceActions.fetchAllLots());
      dispatch(EdgeDeviceActions.fetchAllLanes());
      dispatch(EdgeDeviceActions.fetchAllCameras());
    });
  }, [dispatch]);

  const cameraTypeOptions = React.useMemo(() => {
    return [
      {
        label: "None",
        value: "None",
      },
      {
        label: "WS1",
        value: "WS1",
      },
      {
        label: "WS2",
        value: "WS2",
      },
      {
        label: "WS3",
        value: "WS3",
      },
    ];
  }, []);

  const lotValue = React.useMemo(() => {
    const lot = (lotData ?? []).find((x) => x.id === configData.lot_id);
    return lot ? { value: lot.id, label: lot.alias } : null;
  }, [lotData, configData.lot_id]);

  const laneValue = React.useMemo(() => {
    const lane = (laneData ?? []).find((x) => x.id === configData.lane_id);
    return lane ? { value: lane.id, label: lane.alias } : null;
  }, [laneData, configData.lane_id]);

  const dropdownModeValue = React.useMemo(() => {
    console.log("config::----", config);
    const modeValue = config.filter((item) => {
      return item.data;
    });
    if (config.length > 0 && modeValue.length > 0) {
      const dropdownmode = (modeValue[0].data ?? []).find(
        (x) => x.alias === configData.mode
      );
      return dropdownmode ? dropdownmode.alias : null;
    }
  }, [config, configData.mode]);

  const dropdownMaxchargeValue = React.useMemo(() => {
    const maxchargeValue = config.filter((item) => {
      return item.data;
    });
    if (config.length > 0 && maxchargeValue.length > 0) {
      const dropdownmaxcharge = (maxchargeValue[0].data ?? []).find(
        (x) => x.alias === configData.maxcharge
      );
      return dropdownmaxcharge ? dropdownmaxcharge.alias : null;
    }
  }, [config, configData.maxcharge]);

  const dropdownRateValue = React.useMemo(() => {
    const rateValue = config.filter((item) => {
      return item.data;
    });
    if (config.length > 0 && rateValue.length > 0) {
      const dropdownrate = (config[9].data ?? []).find(
        (x) => x.alias === configData.rate
      );
      return dropdownrate ? dropdownrate.alias : null;
    }
  }, [config, configData.rate]);

  const cameraValue = React.useMemo(() => {
    const camera = (cameraData ?? []).find(
      (x) => x.id === configData.camera_id
    );
    return camera ? { value: camera.id, label: camera.ip_addr } : null;
  }, [cameraData, configData.camera_id]);

  return (
    <div>
      <Modal
        lg={"medium"}
        show={modelOpenCLose}
        backdrop={"static"}
        onHide={handleClose}
        dialogClassName="modal-90w"
        fullscreen={"sm-down"}
      >
        <Card.Header className="d-flex justify-content-between bg-white align-items-center">
          <h4 className="m-0 font-weight-bold">
            <Card.Title className="m-0">Add Edge Device</Card.Title>
          </h4>
          <Button
            title={"Deactivate"}
            type="button"
            onClick={handleClose}
            className="close-btn py-0"
            data-dismiss="modal"
          >
            <i className="nc-icon nc-simple-remove text-danger" />
          </Button>
        </Card.Header>

        <ModalBody>
          <Form.Group>
            {apiMessage &&
              apiMessage.message !== "" &&
              apiMessage.isSuccess === false && (
                <Row>
                  <ErrorCol>
                    <span className="help-block">{apiMessage.message}</span>
                  </ErrorCol>
                </Row>
              )}
            <ScrollBar
              containerRef={(el) => {
                scrollRef.current = el;
              }}
              ref={scrollRef}
            >
              <Row>
                <Col>
                  <FieldWrapper
                    className="form-group mb-2"
                    hasError={!!validations.type}
                  >
                    <Form.Label className="mb-0">
                      Device Type
                      {!configData.id ? (
                        <span className="asterisk">*</span>
                      ) : null}
                    </Form.Label>
                    <Form.Control
                      as="select"
                      name="type"
                      placeholder="Device Type"
                      value={configData.type}
                      onChange={changeDeviceType}
                    >
                      <option value="">--Select Device Type--</option>
                      {(deviceTypes ?? []).map((e, key) => {
                        return (
                          <option key={key} value={e.type}>
                            {e.type}
                          </option>
                        );
                      })}
                    </Form.Control>
                    {validations.type && (
                      <ErrorSpan>{validations.type}</ErrorSpan>
                    )}
                  </FieldWrapper>
                  <FieldWrapper
                    className="form-group mb-2"
                    hasError={!!validations.device_name}
                  >
                    <Form.Label className="mb-0">
                      Device Name
                      {!configData.id ? (
                        <span className="asterisk">*</span>
                      ) : null}
                    </Form.Label>
                    <FormInput
                      type="text"
                      placeholder="device_name"
                      value={configData.device_name}
                      name="device_name"
                      // value={this.state.value}
                      onChange={handleChange}
                    />
                    {validations.device_name && (
                      <ErrorSpan>{validations.device_name}</ErrorSpan>
                    )}
                  </FieldWrapper>
                  <SelectFieldWrapper
                    className="form-group mb-2"
                    hasError={!!validations.lot_id}
                  >
                    <Form.Label className="mb-0">
                      Select Lot
                      {(configData.type === "VPC" ||
                        configData.type === "ILC" ||
                        configData.type === "SILC" ||
                        configData.type === "Feedback" ||
                        configData.type === "TicketDispenser" ||
                        configData.type === "PaymentKiosk") &&
                      !configData.id ? (
                        <span className="asterisk">*</span>
                      ) : null}
                    </Form.Label>
                    <Select
                      name="lot_id"
                      value={lotValue}
                      menuPortalTarget={modalRef.current}
                      onChange={changeLot}
                      options={lotOptions}
                    />
                    {validations.lot_id && (
                      <ErrorSpan>{validations.lot_id}</ErrorSpan>
                    )}
                  </SelectFieldWrapper>
                  <SelectFieldWrapper
                    className="form-group mb-2"
                    hasError={!!validations.lane_id}
                  >
                    <Form.Label className="mb-0">
                      Select Lane
                      {(configData.type === "VPC" ||
                        configData.type === "ILC" ||
                        configData.type === "SILC" ||
                        configData.type === "Feedback" ||
                        configData.type === "TicketDispenser" ||
                        configData.type === "PaymentKiosk") &&
                      !configData.id ? (
                        <span className="asterisk">*</span>
                      ) : null}
                    </Form.Label>
                    <Select
                      name="lane_id"
                      menuPortalTarget={modalRef.current}
                      value={laneValue}
                      onChange={changeLane}
                      options={laneOptions}
                    />
                    {validations.lane_id && (
                      <ErrorSpan>{validations.lane_id}</ErrorSpan>
                    )}
                  </SelectFieldWrapper>
                  <SelectFieldWrapper
                    className="form-group mb-2"
                    hasError={!!validations.camera_id}
                  >
                    <Form.Label className="mb-0">
                      Select Camera
                      {(configData.type === "VPC" ||
                        configData.type === "ILC" ||
                        configData.type === "SILC" ||
                        configData.type === "Feedback") &&
                      !configData.id ? (
                        <span className="asterisk">*</span>
                      ) : null}
                    </Form.Label>
                    <Select
                      name="camera_id"
                      value={cameraValue}
                      menuPortalTarget={modalRef.current}
                      onChange={changeCamera}
                      options={cameraOptions}
                    />
                    {validations.camera_id && (
                      <ErrorSpan>{validations.camera_id}</ErrorSpan>
                    )}
                  </SelectFieldWrapper>
                  <FieldWrapper
                    className="form-group mb-2"
                    hasError={!!validations.white_list_ip}
                  >
                    <label className="mb-0">{"Whiltelist ip"}</label>
                    <FormInput
                      placeholder={"white_list_ip"}
                      type={"text"}
                      name={"white_list_ip"}
                      value={configData.white_list_ip}
                      onChange={handleChange}
                      className="form-group"
                      autoComplete="off"
                      required
                    />
                    {validations.white_list_ip && (
                      <ErrorSpan>{validations.white_list_ip}</ErrorSpan>
                    )}
                  </FieldWrapper>
                  <FieldWrapper
                    className="form-group mb-2"
                    hasError={!!validations.white_list_port}
                  >
                    <label className="mb-0">{"Whiltelist port"}</label>
                    <FormInput
                      placeholder={"white_list_port"}
                      type={"tel"}
                      name={"white_list_port"}
                      value={configData.white_list_port}
                      onChange={handleChange}
                      className="form-group"
                      autoComplete="off"
                      required
                    />
                    {validations.white_list_port && (
                      <ErrorSpan>{validations.white_list_port}</ErrorSpan>
                    )}
                  </FieldWrapper>
                  {(config ?? []).map((device, index) => {
                    if (
                      device.field_name !== "camera_type" &&
                      (device.field_type === "text" ||
                        device.field_type === "password" ||
                        device.field_type === "tel" ||
                        device.field_type === "number")
                    ) {
                      return (
                        <FieldWrapper
                          key={`${device.id}_${index}`}
                          className="form-group mb-2"
                          hasError={!!validations[device.field_name]}
                        >
                          <label className="mb-0">{device.field_label}</label>
                          {(device.field_name === "mac_id" ||
                            device.field_name === "serial_number") &&
                          !configData.id ? (
                            <span className="asterisk">*</span>
                          ) : null}
                          <FormInput
                            placeholder={device.field_label}
                            type={device.field_type}
                            name={device.field_name}
                            value={configData[device.field_name]}
                            onChange={handleChange}
                            className="form-group"
                            autoComplete="new-password"
                            min={device.field_type === "number" && 0}
                            // max={device.field_type === "number" && 24}
                            required
                          />
                          {validations[device.field_name] && (
                            <ErrorSpan>
                              {validations[device.field_name]}
                            </ErrorSpan>
                          )}
                        </FieldWrapper>
                      );
                    } else if (device.field_name === "camera_type") {
                      const value = cameraTypeOptions.find(
                        (x) => x.value === configData[device.field_name]
                      );
                      return (
                        <FieldWrapper
                          key={`${device.id}_${index}`}
                          className="form-group mb-2"
                          hasError={!!validations.camera_type}
                        >
                          <Form.Label className="mb-0">
                            {device.field_label}
                            {device.field_required && !configData.id ? (
                              <span className="asterisk">*</span>
                            ) : null}
                          </Form.Label>
                          <Select
                            name={device.field_name}
                            value={value}
                            menuPortalTarget={modalRef.current}
                            onChange={changeCameraType}
                            options={cameraTypeOptions}
                          />
                          {validations.camera_type && (
                            <ErrorSpan>{validations.camera_type}</ErrorSpan>
                          )}
                        </FieldWrapper>
                      );
                    } else if (device.field_type === "switch") {
                      return (
                        <div
                          className="form-group mb-2 d-flex align-items-center"
                          key={`${device.id}_${index}`}
                        >
                          <React.Fragment key={device.id}>
                            <Form.Check
                              placeholder={device.field_label}
                              id={device.field_name}
                              type={device.field_type}
                              name={device.field_name}
                              label={device.field_label}
                              onChange={handleCheckboxChange}
                              checked={configData[device.field_name]}
                              value={configData[device.field_name]}
                              className="mb-1"
                              // className="form-group"
                              autoComplete="new-password"
                              min={device.field_type === "number" && 0}
                              // max={device.field_type === "number" && 24}
                              required
                            />
                          </React.Fragment>
                        </div>
                      );
                    } else if (device.field_type === "dropdown") {
                      return (
                        <FieldWrapper
                          className="form-group mb-2"
                          hasError={!!validations.type}
                          key={index}
                        >
                          <Form.Label className="mb-0">
                            {device.field_label}
                          </Form.Label>
                          {device.field_name === "mode" && !configData.id ? (
                            <span className="asterisk">*</span>
                          ) : null}
                          <Form.Control
                            as="select"
                            name={device.field_name}
                            placeholder={device.field_label}
                            value={
                              device.field_name === "mode"
                                ? dropdownModeValue
                                : device.field_name === "maxcharge"
                                ? dropdownMaxchargeValue
                                : device.field_name === "rate"
                                ? dropdownRateValue
                                : ""
                            }
                            onChange={(e) => changeDeviceTypeDropdown(e)}
                          >
                            <option value="">
                              {device.default_field_value}
                            </option>
                            {(device?.data ?? []).map((e, key) => {
                              return (
                                <option
                                  key={key}
                                  value={e.alias}
                                  label={e.alias}
                                >
                                  {e.alias}
                                </option>
                              );
                            })}
                          </Form.Control>
                          {validations.mode && device.field_name === "mode" && (
                            <ErrorSpan>{validations.mode}</ErrorSpan>
                          )}
                        </FieldWrapper>
                      );
                    } else {
                      return <React.Fragment key={index} />;
                    }
                  })}
                </Col>
              </Row>
            </ScrollBar>
          </Form.Group>
        </ModalBody>
        <Modal.Footer>
          <Button
            className="btn-fill"
            type="button"
            variant="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className="btn-fill"
            type="button"
            variant="info"
            onClick={handleAddFields}
          >
            {configData && configData.id ? "Edit" : "Add"} Edge Device
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddEdgeDeviceTypeFunc;
const ScrollBar = styled(PerfectScrollbar)`
  max-height: calc(100vh - 300px);
  padding-right: 24px;
  padding-left: 24px;
  .ps__rail-x {
    dispay: none !important;
  }
  .row {
    margin-right: 0px;
    margin-left: 0px;
  }
`;
const ErrorCol = styled(Col)`
  margin-left: 38px;
  margin-bottom: 14px;
`;
const ModalBody = styled(Modal.Body)`
  padding-right: 0px !important;
  padding-left: 0px !important;
`;
const ErrorSpan = styled.span`
  color: #ff3939;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const FormInput = styled(Form.Control)`
  margin-bottom: 0px;
`;

const FieldWrapper = styled.div`
  ${(props) =>
    props.hasError
      ? " label { color: #f44141 !important; } input, select { border-color: #f44141 !important; }"
      : ""}
`;
const SelectFieldWrapper = styled.div`
  ${(props) =>
    props.hasError
      ? " label { color: #f44141; } div > div { border-color: #f44141; }"
      : ""}
`;
